
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getOverridesMap = function getOverridesMap(overrideParam) {
  var map = {};
  var regex = /,?([^=]+)=([^=]+)(?=,|$)/g;
  var match = void 0;
  do {
    match = regex.exec(overrideParam);
    if (match && match.length > 2) {
      var key = match[1].trim();
      var value = match[2].trim();
      map[key] = value;
    }
  } while (match);

  return map;
};

/* eslint-disable santa/no-starts-with */
var isScriptValid = function isScriptValid(url, scriptsLocation) {
  return url.startsWith(scriptsLocation) || url.startsWith('https://sled.wix.dev') || // used by Sled, a cloud test runner - https://wix-private.github.io/sled/
  url.startsWith('https://localhost') || url.startsWith('http://localhost');
};

var overrideViewerScripts = function overrideViewerScripts(clientSpecMap, overrideParam, scriptsLocation) {
  if (!overrideParam) {
    return;
  }

  var overridesMap = getOverridesMap(overrideParam);

  Object.keys(clientSpecMap).forEach(function (applicationId) {
    var applicationSpec = clientSpecMap[applicationId];
    var overridenScript = overridesMap[applicationSpec.appDefinitionId];

    if (overridenScript && isScriptValid(overridenScript, scriptsLocation) && applicationSpec.appFields && applicationSpec.appFields.platform && applicationSpec.appFields.platform.viewerScriptUrl) {
      applicationSpec.appFields.platform.viewerScriptUrl = overridenScript;
    }
  });
};

var overrideWidgetScripts = function overrideWidgetScripts(clientSpecMap, overrideParam, scriptKeyName, scriptsLocation) {
  if (!overrideParam) {
    return;
  }

  var overridesMap = getOverridesMap(overrideParam);

  Object.keys(clientSpecMap).forEach(function (applicationId) {
    var applicationWidgets = clientSpecMap[applicationId].widgets || {};
    Object.keys(applicationWidgets).forEach(function (widgetId) {
      var urlOverride = overridesMap[widgetId];

      if (urlOverride && isScriptValid(urlOverride, scriptsLocation) && applicationWidgets[widgetId].componentFields) {
        var componentFields = applicationWidgets[widgetId].componentFields;
        componentFields[scriptKeyName] = componentFields[scriptKeyName] || '';
        componentFields[scriptKeyName] = urlOverride;
      }
    });
  });
};

var overridePlatformBaseUrls = function overridePlatformBaseUrls(clientSpecMap, overrideParam, scriptsLocation) {
  if (!overrideParam) {
    return;
  }

  var overridesMap = getOverridesMap(overrideParam);

  Object.keys(overridesMap).forEach(function (key) {
    var baseUrlsOverride = null;
    try {
      baseUrlsOverride = JSON.parse(overridesMap[key]);
    } catch (ex) {
      delete overridesMap[key];
      return;
    }

    overridesMap[key] = Object.keys(baseUrlsOverride).map(function (baseUrlKey) {
      return {
        key: baseUrlKey,
        value: baseUrlsOverride[baseUrlKey]
      };
    }).filter(function (_ref) {
      var value = _ref.value;
      return typeof value === 'string' && isScriptValid(value, scriptsLocation);
    });
  });

  Object.keys(clientSpecMap).forEach(function (applicationId) {
    var applicationSpec = clientSpecMap[applicationId];
    var baseUrlsOverrides = overridesMap[applicationSpec.appDefinitionId];

    if (!baseUrlsOverrides) {
      return;
    }

    // eslint-disable-next-line lodash/prefer-get
    if (applicationSpec.appFields && applicationSpec.appFields.platform && applicationSpec.appFields.platform.baseUrls) {
      baseUrlsOverrides.forEach(function (_ref2) {
        var key = _ref2.key,
            value = _ref2.value;

        applicationSpec.appFields.platform.baseUrls[key] = value;
      });
    }
  });
};

var mergeOverrideScriptsInClientSpecMap = function mergeOverrideScriptsInClientSpecMap() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var options = {};
  if (args.length === 1) {
    options = args[0];
  } else {
    var clientSpecMap = args[0],
        _args$ = args[1],
        viewerScriptOverrideParam = _args$ === undefined ? '' : _args$,
        _args$2 = args[2],
        controllerScriptsOverrideParam = _args$2 === undefined ? '' : _args$2,
        _args$3 = args[3],
        componentScriptsOverrideParam = _args$3 === undefined ? '' : _args$3,
        scriptsLocation = args[4];


    options = {
      clientSpecMap: clientSpecMap,
      viewerScriptOverrideParam: viewerScriptOverrideParam,
      controllerScriptsOverrideParam: controllerScriptsOverrideParam,
      componentScriptsOverrideParam: componentScriptsOverrideParam,
      scriptsLocation: scriptsLocation
    };
  }

  overrideViewerScripts(options.clientSpecMap, options.viewerScriptOverrideParam, options.scriptsLocation);
  overrideWidgetScripts(options.clientSpecMap, options.controllerScriptsOverrideParam, 'controllerUrl', options.scriptsLocation);
  overrideWidgetScripts(options.clientSpecMap, options.componentScriptsOverrideParam, 'componentUrl', options.scriptsLocation);
  overridePlatformBaseUrls(options.clientSpecMap, options.overridePlatformBaseUrlsParam, options.scriptsLocation);
};

exports.default = mergeOverrideScriptsInClientSpecMap;
//# sourceMappingURL=overrideClientSpecMapScriptsFromQuery.js.map